import { render, staticRenderFns } from "./steps-compact.vue?vue&type=template&id=7cf4a4d4"
import script from "./steps-compact.vue?vue&type=script&lang=ts"
export * from "./steps-compact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports